import { useState, useEffect, useRef, Dispatch, SetStateAction } from 'react';
import { Box, MenuItem } from '@mui/material';
import pannelState from 'state/rightPannelState';
import { useRecoilState } from 'recoil';
import { GridArea } from 'components/common/GridArea';
import { AgGridReact } from 'ag-grid-react';
import { CropSchema } from 'constant/CropSchema';
import { Crop } from '@crops';
import { Control, useWatch } from 'react-hook-form';
import { EmptyContent, StyledSelect } from 'packages/ui/src/components';
import { RowClickedEvent } from 'ag-grid-community';
import { TPaging, TStateMap } from '@metadata';
import mapState from 'state/mapState';
import { JGAMap } from '@ui/libs/Map';

type Props = {
  control: Control<Crop.FormData, any>;
  detailList: Crop.TAiListResponse;
  paging: TPaging;
  setPaging: Dispatch<SetStateAction<TPaging>>;
  excelDownload: any;
};

const AiListGrid = ({ control, detailList, setPaging, paging, excelDownload }: Props) => {
  const [pannel, setPannel] = useRecoilState(pannelState);
  const [mapInfo, setMap] = useRecoilState(mapState);



  const moveToDetail = (e: RowClickedEvent<Crop.TAiListData>) => {
    const id = e.data.obj_id;
    setMap((prev: TStateMap) => ({ ...prev, status: { ...prev.status, obj_id: e.data.obj_id } }));

  };

  return (
    <div className="cListTableWrap cLimitTableWrap hide pt40">
      {detailList.total && detailList.total.total > 0 ? (
        <>
          <AiReportHead
            control={control}
            setPaging={setPaging}
            excelDownload={excelDownload}
            detailList={detailList}
          />
          <AiReportGrid
            control={control}
            data={detailList}
            setPaging={setPaging}
            paging={paging}
            moveToDetail={moveToDetail}
          />
        </>
      ) : (
        <EmptyContent text="신고 내역이 존재하지 않습니다." />
      )}
    </div>
  );
};

const AiReportHead = ({ control, setPaging, excelDownload, detailList }) => {
  const _pageSize = useWatch<Crop.FormData>({ control, name: 'pageSize' });
  useEffect(() => {
    setPaging((prev) => ({ ...prev, pageSize: _pageSize }));
  }, [_pageSize]);

  return (
    <Box className="cTableTopArea">
      <div className="cTableTopLeft">
        <div className="cTableTopTit">상세목록</div>
        <StyledSelect
          name="pageSize"
          control={control}
          sx={{ minWidth: 'auto' }}
        >
          <MenuItem value="10">10개</MenuItem>
          <MenuItem value="20">20개</MenuItem>
          <MenuItem value="30">30개</MenuItem>
          <MenuItem value="50">50개</MenuItem>
        </StyledSelect>
      </div>
      <div className="cTableTopRight">
        {detailList.total ? (
          <ul className="cTableTopData">
            <li>
              총 <span className="num">{detailList.total.total}</span> 건
            </li>
            <li>
              총 면적 <span className="num">{detailList.total.totalarea.toFixed(1)}</span>㎡
            </li>
          </ul>
        ) : null}
        <button
          type="button"
          className="bLineType05 bDownload"
          onClick={excelDownload}
        >
          <span>엑셀 다운로드</span>
        </button>
      </div>
    </Box>
  );
};

const AiReportGrid = ({
  control,
  data,
  setPaging,
  paging,
  moveToDetail,
}: {
  control: Control<Crop.FormData, any>;
  data: Crop.TAiListResponse;
  setPaging: Dispatch<SetStateAction<TPaging>>;
  paging: TPaging;
  moveToDetail: (e) => void;
}) => {
  const gridAiRef = useRef<AgGridReact>(null);
  const onFirstDataRendered = (params) => {
    params.api.sizeColumnsToFit();
  };


  const pageSize = useWatch({ control, name: 'pageSize' });

  useEffect(() => {
    console.log('pageSize', pageSize);
    setPaging((prev) => ({ pageSize:pageSize, pageNo: 0 }));
  }, [pageSize]);


const onCellClicked = (event) => {
  if (event.colDef.field === 'wkt') {
    moveToDetail(event);
  }
};

  const setPage = (number: number) => {
    setPaging((prev) => ({ ...prev, pageNo: number - 1 }));
  };

  return (
    <Box className="cListTableWrap ">
      <div className="cListTableArea withCursor">
        <GridArea
          gridRef={gridAiRef}
          rowData={data.data}
          total={Math.ceil(Number(data.total.total) / paging.pageSize)}
          page={paging.pageNo+1}
          setPage={setPage}
          columnDefs={CropSchema.aiFeatureList.columnDefs}
          onFirstDataRendered={onFirstDataRendered}
          onCellClicked={onCellClicked}
          defaultColDef={{
            sortable: true,
            resizable: true,
          }}
          domLayout="autoHeight"
        />
      </div>
    </Box>
  );
};

export default AiListGrid;
